<template>
  <div class="fileWrapper">
    <input
      ref="file"
      type="file"
      :name="id_"
      :id="id_"
      class="file"
      :accept="filters"
      :multiple="multiple"
    />
    <label v-if="slotIsEmpty" class="label" :for="id_">{{ label ? label : $t( "SELECTFILE" ) }}</label>
    <label v-else :for="id_"><slot :select="select"></slot></label>
  </div>
</template>

<script>
import utils from "@/utils"

export default {
  name: "File",

  i18n: {
    messages: {
      ru: {
        SELECTFILE: "ВЫБЕРИТЕ ФАЙЛ"
      },

      en: {
        SELECTFILE: "SELECT THE FILE"
      },

      kz: {
        SELECTFILE: "ФАЙЛДЫ ТАҢДАҢЫЗ"
      }
    }
  },

  props: {
    label: {
      type: String,
      default: function () { return this.$t( "SELECTFILE" ) }
    },
    id : {
      type: String
    },
    value: {
      default: null
    },
    filters: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      id_: this.id ? id : utils.uniqueHashGen( "file" )
    };
  },

  mounted() {
    if ( this.$refs.file ) {
      const el = this.$refs.file;
      const elLabel = el.nextElementSibling;

      el.addEventListener(
        "change",
          () => {
            let fns = "";
            const fs = el.files ? el.files : [ { name: el.value } ];
            for ( const f of fs ) {
              const fn = f.name.replace( /^.*?\/([^\/]+)$/, "$1" );
              if ( fn ) fns += ( fns ? ", " : "" ) + fn;
            }

            if ( !fns ) fns = this.label;

            if ( this.slotIsEmpty ) elLabel.innerHTML = fns;

            this.$emit( "input", { el, fn: fns ? fns : null } );
          }
      );
    }
  },
  methods: {
    select() {
      const el = this.$refs.file;
      const elLabel = el.nextElementSibling;
      elLabel.click();
    }
  },

  computed: {
    slotIsEmpty() {
      return !this.$scopedSlots.default;
    }
  },

  watch: {
    value( v ) {
      if ( v === null && this.$refs.file ) {
        const el = this.$refs.file;
        el.value = null;
        el.dispatchEvent( new Event( "change", { bubbles: true } ) );
      }
    }
  }
}
</script>

<style scoped>
.file {
    width: .1px;
    height: .1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.file + label {
    display: inline-block;
}

.file + label.label {
    display: inline-block;
    border: 2px solid #007BC1;
    color: #007BC1;
    fill: #007BC1;
    border-radius: 0.2em;
    font-size: inherit;
    align-items: center;
    padding: 0.5em 1em;
    -webkit-transition: all .5s ease 0s;
    transition: all .5s ease 0s;
    cursor: pointer;
    font-weight: 500;
    max-width: 10em;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file:focus + label.label {
  color: #000000;
}

.file + label.label:hover {
    color: #0C97E7;
    fill: #0C97E7;
    border-color: #0C97E7;
}

.inputfile + label * {
    pointer-events: none;
}
</style>